import React, { useState } from "react";
import api from "../api";
import { useNavigate, Link } from "react-router-dom";
import "../App.css";

export default function Login({ setIsLoggedIn }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false); // 🔹 état chargement
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); // 🔹 démarre le chargement

    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("token", res.data.token);
      setIsLoggedIn(true);
      navigate("/tasks");
    } catch (err) {
      alert("Erreur de connexion");
    } finally {
      setLoading(false); // 🔹 stop le chargement
    }
  };

  return (
    <div className="auth-container">
      <form onSubmit={handleLogin}>
        <h2>Connexion</h2>

        <p
          style={{
            textAlign: "center",
            color: "#94a3b8",
            marginBottom: "10px",
          }}
        >
          Bon retour parmi nous !
        </p>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={loading} // 🔹 désactivé pendant chargement
        />

        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={loading}
        />

        <button
          type="submit"
          className="btn-primary"
          disabled={loading} // 🔹 empêche double clic
        >
          {loading ? "Connexion en cours..." : "Se connecter"}
        </button>

        {loading && (
          <p
            style={{
              textAlign: "center",
              marginTop: "10px",
              color: "#00d2ff",
              fontSize: "0.9rem",
            }}
          >
            ⏳ Vérification de vos identifiants...
          </p>
        )}

        {!loading && (
          <p
            style={{
              marginTop: "15px",
              textAlign: "center",
              fontSize: "0.9rem",
            }}
          >
            Pas encore de compte ?{" "}
            <Link
              to="/register"
              style={{ color: "#00d2ff", textDecoration: "none" }}
            >
              S'inscrire
            </Link>
          </p>
        )}
      </form>
    </div>
  );
}
